import isEmpty from 'lodash.isempty';
import omitBy from 'lodash.omitby';
import queryString from 'query-string';
import { useNavigate } from 'react-router';

export const useQueryParams = <T>(
  search: string,
  defaultState?: T
): {
  urlParams: T;
  updateURLWithQueryParams: <T>(path: string, query: T) => void;
} => {
  const navigate = useNavigate();

  const params = queryString.parse(search, {
    parseNumbers: true,
  }) as never as T;

  const updateURLWithQueryParams = <T>(path: string, query: T): void => {
    const cleanedQuery = cleanQueryParams(query);
    navigate({ pathname: path, search: cleanedQuery }, { replace: true });
  };

  return {
    urlParams: Object.keys(params).length > 0 ? params : defaultState || null,
    updateURLWithQueryParams,
  };
};

export const cleanQueryParams = <T>(params: T): string => {
  const cleanedParams = omitBy(params as never, (value) => {
    return value === '' || value === null;
  });

  return !isEmpty(cleanedParams)
    ? `?${queryString.stringify(cleanedParams as never)}`
    : '';
};
